import React from 'react';
import './VatNotification.css';

interface VatNotificationProps {
  vatPercentage: number;
  vatAmount: number;
  isInclusive: boolean;
  onDismiss?: () => void;
  className?: string;
}

const VatNotification: React.FC<VatNotificationProps> = ({
  vatPercentage,
  vatAmount,
  isInclusive,
  onDismiss,
  className = ''
}) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };

  return (
    <div className={`vat-notification ${className}`}>
      <div className="vat-notification__icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="vat-notification__content">
        <h4 className="vat-notification__title">VAT Information</h4>
        <p className="vat-notification__message">
          {isInclusive ? (
            <>Prices include {vatPercentage}% VAT ({formatPrice(vatAmount)})</>
          ) : (
            <>{vatPercentage}% VAT ({formatPrice(vatAmount)}) will be added to your order</>
          )}
        </p>
      </div>
      {onDismiss && (
        <button
          className="vat-notification__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss VAT notification"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default VatNotification;
